<template>
    <el-dialog
        :title="title"
        v-model="dialogVisible"
        width="30%"
        :before-close="handleClose">
        <el-form ref="form" :model="form"  :rules="rules">
            <el-form-item label="名称:" prop="schoolName" label-width="100px">
                <el-input  v-model="form.schoolName"  autocomplete="off"></el-input>
        </el-form-item>
          <el-form-item label="编号:"  label-width="100px">
              <el-input  v-model="form.code"  autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="SIID:"  label-width="100px">
              <el-input  v-model="form.siId"  autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="地址:" label-width="100px">
              <el-input  v-model="form.address"  autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="备注:" label-width="100px">
            <el-input
                type="textarea"
                :rows="2"
                placeholder="请输入内容"
                v-model="form.remark">
                </el-input>
          </el-form-item>
            <div class="buttom-box">
                    <el-button type="primary" class="tijiaoBtn" @click="onSubmit('form')">提交</el-button>
                    <el-button @click="handleClose">返回</el-button>
                </div>
    </el-form>
        
    </el-dialog>
</template>
<script>
import { schoolOrUserAdd,schoolOrUserSchoolInfo,schoolInfoXiugai } from '@/assets/api/schoollog'
import { ElMessage } from 'element-plus'

export default {
    components: {
    },
     props: ['xiugaiObj'],
    data() {

        return {
            dialogVisible: true,
            title:'',
            form:{
                siId:'',
                code:'',
                address:'',
                remark:"",
                schoolName:''
            },
            cardid:"",
            rules: {
                schoolName: [
                        { required: true, message: '请输入名称', trigger: 'blur' },
                      ],
            }
        }

    },
    created(){
    },
    mounted(){
        if (JSON.stringify(this.xiugaiObj) !== "{}") {
            this.title = '修改组织'
            const params = {
                schoolId:this.xiugaiObj.id
            }
            schoolOrUserSchoolInfo(params).then((res) => {
                this.form.code = res.data.data.code
                this.form.schoolName = res.data.data.name
                this.form.address = res.data.data.address
                this.form.siId = res.data.data.siId
                this.form.description= res.data.data.description
                console.log(res,'成功');
                
            }).catch((err) => {
                console.log(err,'失败');
                
            })
            console.log('修改学校');

        }else{
            console.log(this.xiugaiObj,'新增imei');
            this.title = '新增组织'

        }
        
    },
    methods:{
        handleClose() {
            this.$emit('AddShowClick')
      },
      //新增
     schoolOrUserAddXinzeng(){
        const params = {
            code:this.form.code,
            address:this.form.address,
            siid:this.form.siId,
            remark:this.form.remark,
            schoolName:this.form.schoolName,
            userId: JSON.parse(localStorage.getItem('user')).id,
        }
        schoolOrUserAdd(params).then((res) => {
            ElMessage.success('新增成功')
            this.handleClose()
            
        }).catch((err)=> {
            // ElMessage.error("新增失败");
            // console.log(err,'');
            this.$message({
                    type: 'error',
                    message: err.response.data.msg
                });


        })
      },
    //   修改
      schoolInfoShow(){
        const params = {
            code:this.form.code,
            address:this.form.address,
            remark:this.form.remark,
            schoolName:this.form.schoolName,
            siId:this.form.siId,
            schoolId:this.xiugaiObj.id,
            userId:JSON.parse(localStorage.getItem('user')).id,
        }
        schoolInfoXiugai(params,this.cardid).then((res) => {
            console.log(res,'2');
            ElMessage.success('修改成功')
            this.handleClose()

        }).catch((err)=> {
            // ElMessage.error("修改失败");
            console.log(err,'失败');

        })
      },
      onSubmit(formName) {
        // console.log(formName);
        this.$refs[formName].validate((valid) => {
            //   if (valid) {
                if( this.title == '修改组织') {
                    //   console.log('修改',8888);
                      this.schoolInfoShow()
                    
                } else if( this.title == '新增组织'){
                    this.schoolOrUserAddXinzeng()
                }
            //   } else {
            //       return false;

            //   }
              });
          },

    }
    }




</script>
<style  scoped lang="scss">
    :deep() {
        .el-input--small .el-input__wrapper{
            height: 35px;
            line-height: 35px;
            text-align: center;
            width: 280px;
        }
        .el-input__inner{
            // width: 10px !important;
        }
        .buttom-box {
        // text-align: center;
        margin-left: 180px;
         .tijiaoBtn{
            // background-color : #1BC896;
        }

    }
    
    .el-form-item--small{
        width: 70% !important;
    }
    }
</style>